import { Component, ViewEncapsulation, inject } from "@angular/core";
import { UserAuthenticationService } from "../shared/user-authentication.service";
import { Subject } from "rxjs";
import { LoginComponent } from "../login/login.component";

@Component({
    selector: "login-modal",
    templateUrl: "./login-modal.component.html",
    styleUrls: ["./login-modal.component.scss"],
    encapsulation: ViewEncapsulation.None,
    imports: [LoginComponent],
})
export class LoginModalComponent {
    private authService = inject(UserAuthenticationService);

    loginObservable$: Subject<never>;
    showModal = false;

    constructor() {
        this.authService.handleSessionExpiredEvent.subscribe((subj) => {
            this.loginObservable$ = subj;
            this.showModal = true;
        });
    }

    loginCompleted() {
        this.showModal = false;
        this.loginObservable$.next(<never>null);
        this.loginObservable$.complete();

        this.loginObservable$ = null;
    }
}
